import moment from "moment";

export default function initializeArrivalDate(arrival) {
  if (arrival.length) {
    return arrival;
  }
  // 7 days after tomorrow (tomorrow + 7 days = 8 days from today)
  return moment()
    .add(8, "days")
    .set("hours", 12)
    .set("minutes", 0)
    .format("yyyy-MM-DD HH:mm");
}
